import { defineTranslateKeys } from 'lib/tolgee'

export const postsTranslations = defineTranslateKeys({
  tooltipUpdated: ({ day, time }: { day: 'today' | 'yesterday'; time: string }) => ({
    key: 'Posts-tooltipUpdated',
    parameters: { day, time },
    defaultValue:
      'Atualizado {day, select, today {hoje} yesterday {ontem} other {}} às {time}{day, select, today {. Próxima atualização estará disponível amanhã} other {}}',
  }),
})
